import styled from 'styled-components';
import { themeColor } from '../theme/colors';

const Container = styled.div``;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: ${themeColor('backgroundLight')};
  border-radius: 12px;
  border: 1px solid ${themeColor('strokePrimary')};
  color: ${themeColor('textSecondary')};

  padding: 32px;
  position: relative;
  max-width: 800px;
  margin-left: 80px;
  margin-right: 80px;
  width: 100%;
`;

const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

export const ModalStyles = {
  Container,
  Overlay,
  ModalContent,
  CloseButton,
};
